import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (password !== confirmPassword) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      toast.success('Password reset successfully!');
      setDone(true);
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed to reset password'); }
    finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="hb-bg">
        <div className="hb-content min-h-screen" style={{ justifyContent: 'center' }}>
          <div className="hb-glass-strong" style={{ maxWidth: '480px', textAlign: 'center' }}>
            <h1 style={{ fontSize: '24px', fontWeight: 800, marginBottom: '12px', textShadow: '0 2px 4px rgba(0,0,0,0.55)' }}>Invalid Link</h1>
            <p style={{ color: 'rgba(234,239,245,0.85)', marginBottom: '24px' }}>This password reset link is invalid or has expired.</p>
            <Button data-testid="back-to-login" onClick={() => navigate('/auth')} className="btn-gold">Back to Login</Button>
          </div>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="hb-bg">
        <div className="hb-content min-h-screen" style={{ justifyContent: 'center' }}>
          <div className="hb-glass-strong" style={{ maxWidth: '480px', textAlign: 'center' }}>
            <h1 style={{ fontSize: '24px', fontWeight: 800, marginBottom: '12px', color: '#4ade80', textShadow: '0 2px 4px rgba(0,0,0,0.55)' }}>Password Reset!</h1>
            <p style={{ color: 'rgba(234,239,245,0.85)', marginBottom: '24px' }}>Your password has been updated. You can now log in with your new password.</p>
            <Button data-testid="go-to-login" onClick={() => navigate('/auth')} className="btn-gold">Go to Login</Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="hb-bg">
      <div className="hb-content min-h-screen" style={{ justifyContent: 'center' }}>
        <header style={{ textAlign: 'center', marginBottom: '14px' }}>
          <img src="/harperbids-logo.png" alt="HarperBids" style={{ height: '80px', margin: '0 auto', display: 'block' }} className="hb-logo-glow" />
        </header>
        <div style={{ width: '100%', maxWidth: '820px', height: '1px', marginBottom: '24px', background: 'linear-gradient(90deg, transparent, rgba(201,206,211,0.3), transparent)' }} />

        <div className="hb-glass-strong" style={{ maxWidth: '480px' }}>
          <h1 style={{ margin: '0 0 6px', fontSize: '28px', fontWeight: 800, textShadow: '0 2px 4px rgba(0,0,0,0.55)' }}>Set New Password</h1>
          <p style={{ margin: '0 0 24px', fontSize: '16px', color: 'rgba(234,239,245,0.85)' }}>Enter your new password below</p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label style={{ color: 'var(--text-secondary)' }}>New Password</Label>
              <Input data-testid="new-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 6 characters" required className="h-11 hb-input" />
            </div>
            <div>
              <Label style={{ color: 'var(--text-secondary)' }}>Confirm Password</Label>
              <Input data-testid="confirm-password" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm password" required className="h-11 hb-input" />
            </div>
            <Button type="submit" data-testid="reset-password-button" className="w-full h-11 btn-gold" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
